// The 2-letter Country Code information was pulled from:
// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2

import { CountryLocale } from '../types';

export const sessionLeadLocaleData: Record<string, CountryLocale> = {
  TZ: {
    countryCode: 'TZ',
    country: 'Tanzania',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MW: {
    countryCode: 'MW',
    country: 'Malawi',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  BO: {
    countryCode: 'BO',
    country: 'Bolivia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  BJ: {
    countryCode: 'BJ',
    country: 'Benin',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MA: {
    countryCode: 'MA',
    country: 'Morocco',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  BY: {
    countryCode: 'BY',
    country: 'Belarus',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  AR: {
    countryCode: 'AR',
    country: 'Argentina',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MX: {
    countryCode: 'MX',
    country: 'Mexico',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  AM: {
    countryCode: 'AM',
    country: 'Armenia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  PY: {
    countryCode: 'PY',
    country: 'Paraguay',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MD: {
    countryCode: 'MD',
    country: 'Moldova',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  BD: {
    countryCode: 'BD',
    country: 'Bangladesh',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MK: {
    countryCode: 'MK',
    country: 'Macedonia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  NG: {
    countryCode: 'NG',
    country: 'Nigeria',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  DZ: {
    countryCode: 'DZ',
    country: 'Algeria',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  UG: {
    countryCode: 'UG',
    country: 'Uganda',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  LK: {
    countryCode: 'LK',
    country: 'Sri Lanka',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  CO: {
    countryCode: 'CO',
    country: 'Colombia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  KZ: {
    countryCode: 'KZ',
    country: 'Kazakhstan',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  NP: {
    countryCode: 'NP',
    country: 'Nepal',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  AZ: {
    countryCode: 'AZ',
    country: 'Azerbaijan',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  GE: {
    countryCode: 'GE',
    country: 'Georgia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  UA: {
    countryCode: 'UA',
    country: 'Ukraine',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  UZ: {
    countryCode: 'UZ',
    country: 'Uzbekistan',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  EG: {
    countryCode: 'EG',
    country: 'Egypt',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  EG_EGP: {
    countryCode: 'EG',
    country: 'Egypt',
    localeFactor: 0.6,
    payRatePerHour: '£310.00',
    bonus: '£540.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '£31,000.00',
    currency: 'EGP',
  },
  VE: {
    countryCode: 'VE',
    country: 'Venezuela',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  IN: {
    countryCode: 'IN',
    country: 'India',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  TN: {
    countryCode: 'TN',
    country: 'Tunisia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  PK: {
    countryCode: 'PK',
    country: 'Pakistan',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  MZ: {
    countryCode: 'MZ',
    country: 'Mozambique',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  CM: {
    countryCode: 'CM',
    country: 'Cameroon',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  RW: {
    countryCode: 'RW',
    country: 'Rwanda',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  CD: {
    countryCode: 'CD',
    country: 'Congo, Democratic Republic of the',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  YE: {
    countryCode: 'YE',
    country: 'Yemen',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  ZM: {
    countryCode: 'ZM',
    country: 'Zambia',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  TG: {
    countryCode: 'TG',
    country: 'Togo',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  XK: {
    countryCode: 'XK',
    country: 'Kosovo',
    localeFactor: 0.6,
    payRatePerHour: '$15.00',
    bonus: '$25.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$1,500.00',
  },
  GH: {
    countryCode: 'GH',
    country: 'Ghana',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  CL: {
    countryCode: 'CL',
    country: 'Chile',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  SA: {
    countryCode: 'SA',
    country: 'Saudi Arabia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  AE: {
    countryCode: 'AE',
    country: 'United Arab Emirates',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  TH: {
    countryCode: 'TH',
    country: 'Thailand',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  KH: {
    countryCode: 'KH',
    country: 'Cambodia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  OM: {
    countryCode: 'OM',
    country: 'Oman',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  SV: {
    countryCode: 'SV',
    country: 'El Salvador',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  LT: {
    countryCode: 'LT',
    country: 'Lithuania',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  NI: {
    countryCode: 'NI',
    country: 'Nicaragua',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  CZ: {
    countryCode: 'CZ',
    country: 'Czech Republic',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  SK: {
    countryCode: 'SK',
    country: 'Slovakia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  DO: {
    countryCode: 'DO',
    country: 'Dominican Republic',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  NA: {
    countryCode: 'NA',
    country: 'Namibia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  BR: {
    countryCode: 'BR',
    country: 'Brazil',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  SL: {
    countryCode: 'SL',
    country: 'Sierra Leone',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  ZA: {
    countryCode: 'ZA',
    country: 'South Africa',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  HN: {
    countryCode: 'HN',
    country: 'Honduras',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  HU: {
    countryCode: 'HU',
    country: 'Hungary',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  EC: {
    countryCode: 'EC',
    country: 'Ecuador',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  GT: {
    countryCode: 'GT',
    country: 'Guatemala',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  CU: {
    countryCode: 'CU',
    country: 'Cuba',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  IQ: {
    countryCode: 'IQ',
    country: 'Iraq',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  ME: {
    countryCode: 'ME',
    country: 'Montenegro',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  MY: {
    countryCode: 'MY',
    country: 'Malaysia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  CN: {
    countryCode: 'CN',
    country: 'China',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  PL: {
    countryCode: 'PL',
    country: 'Poland',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  KE: {
    countryCode: 'KE',
    country: 'Kenya',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  VN: {
    countryCode: 'VN',
    country: 'Vietnam',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  MN: {
    countryCode: 'MN',
    country: 'Mongolia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  BG: {
    countryCode: 'BG',
    country: 'Bulgaria',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  PE: {
    countryCode: 'PE',
    country: 'Peru',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  RO: {
    countryCode: 'RO',
    country: 'Romania',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  ID: {
    countryCode: 'ID',
    country: 'Indonesia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  AL: {
    countryCode: 'AL',
    country: 'Albania',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  IR: {
    countryCode: 'IR',
    country: 'Iran',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  BA: {
    countryCode: 'BA',
    country: 'Bosnia And Herzegovina',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  RU: {
    countryCode: 'RU',
    country: 'Russian Federation',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  RS: {
    countryCode: 'RS',
    country: 'Serbia',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  TR: {
    countryCode: 'TR',
    country: 'Turkey',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  PH: {
    countryCode: 'PH',
    country: 'Philippines',
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  CI: {
    countryCode: 'CI',
    country: "Cote d'Ivoire",
    localeFactor: 0.7,
    payRatePerHour: '$30.00',
    bonus: '$50.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$3,000.00',
  },
  TW: {
    countryCode: 'TW',
    country: 'Taiwan',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  QA: {
    countryCode: 'QA',
    country: 'Qatar',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  JM: {
    countryCode: 'JM',
    country: 'Jamaica',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  LB: {
    countryCode: 'LB',
    country: 'Lebanon',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  UY: {
    countryCode: 'UY',
    country: 'Uruguay',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  BH: {
    countryCode: 'BH',
    country: 'Bahrain',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  GR: {
    countryCode: 'GR',
    country: 'Greece',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  CY: {
    countryCode: 'CY',
    country: 'Cyprus',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  JO: {
    countryCode: 'JO',
    country: 'Jordan',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  ES: {
    countryCode: 'ES',
    country: 'Spain',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  SI: {
    countryCode: 'SI',
    country: 'Slovenia',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  MU: {
    countryCode: 'MU',
    country: 'Mauritius',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  MM: {
    countryCode: 'MM',
    country: 'Myanmar',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  TT: {
    countryCode: 'TT',
    country: 'Trinidad And Tobago',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  ZW: {
    countryCode: 'ZW',
    country: 'Zimbabwe',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  KW: {
    countryCode: 'KW',
    country: 'Kuwait',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  PA: {
    countryCode: 'PA',
    country: 'Panama',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  EE: {
    countryCode: 'EE',
    country: 'Estonia',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  FJ: {
    countryCode: 'FJ',
    country: 'Fiji',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  CR: {
    countryCode: 'CR',
    country: 'Costa Rica',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  PT: {
    countryCode: 'PT',
    country: 'Portugal',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  PS: {
    countryCode: 'PS',
    country: 'Palestinian Territory',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  BZ: {
    countryCode: 'BZ',
    country: 'Belize',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  LV: {
    countryCode: 'LV',
    country: 'Latvia',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  HR: {
    countryCode: 'HR',
    country: 'Croatia',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  SN: {
    countryCode: 'SN',
    country: 'Senegal',
    localeFactor: 0.8,
    payRatePerHour: '$40.00',
    bonus: '$60.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$4,000.00',
  },
  CH: {
    countryCode: 'CH',
    country: 'Switzerland',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  IS: {
    countryCode: 'IS',
    country: 'Iceland',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  NO: {
    countryCode: 'NO',
    country: 'Norway',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  BS: {
    countryCode: 'BS',
    country: 'Bahamas',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  LU: {
    countryCode: 'LU',
    country: 'Luxembourg',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  JP: {
    countryCode: 'JP',
    country: 'Japan',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  DK: {
    countryCode: 'DK',
    country: 'Denmark',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  HK: {
    countryCode: 'HK',
    country: 'Hong Kong',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  KR: {
    countryCode: 'KR',
    country: 'South Korea',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  IE: {
    countryCode: 'IE',
    country: 'Ireland',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  FR: {
    countryCode: 'FR',
    country: 'France',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  NL: {
    countryCode: 'NL',
    country: 'Netherlands',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  IL: {
    countryCode: 'IL',
    country: 'Israel',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  BE: {
    countryCode: 'BE',
    country: 'Belgium',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  FI: {
    countryCode: 'FI',
    country: 'Finland',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  NZ: {
    countryCode: 'NZ',
    country: 'New Zealand',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  AU: {
    countryCode: 'AU',
    country: 'Australia',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  AT: {
    countryCode: 'AT',
    country: 'Austria',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  SE: {
    countryCode: 'SE',
    country: 'Sweden',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  SG: {
    countryCode: 'SG',
    country: 'Singapore',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  IT: {
    countryCode: 'IT',
    country: 'Italy',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  DE: {
    countryCode: 'DE',
    country: 'Germany',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  GB: {
    countryCode: 'GB',
    country: 'United Kingdom',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  CA: {
    countryCode: 'CA',
    country: 'Canada',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  PR: {
    countryCode: 'PR',
    country: 'Puerto Rico',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  MT: {
    countryCode: 'MT',
    country: 'Malta',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
  US: {
    countryCode: 'US',
    country: 'United States of America',
    localeFactor: 1,
    payRatePerHour: '$50.00',
    bonus: '$70.00',
    upToHoursPerMonth: '100',
    maxPaymentPerMonth: '$5,000.00',
  },
};
